import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

/**
 * After a new deploy, old hashed chunks (e.g. QueryProvider-xxxx.js) disappear.
 * Tabs still running the previous version then fail to load lazy routes and
 * show a blank screen. Reload once to pick up the fresh build.
 */
const CHUNK_RELOAD_KEY = "chunk-reload-at";
const isChunkError = (msg: unknown) =>
  typeof msg === "string" &&
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk/i.test(msg);

const reloadOnce = () => {
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (Date.now() - last < 10000) return; // avoid reload loops
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
};

window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  reloadOnce();
});
window.addEventListener("error", (e) => {
  if (isChunkError(e.message) || isChunkError(e.error?.message)) reloadOnce();
});
window.addEventListener("unhandledrejection", (e) => {
  if (isChunkError(e.reason?.message ?? e.reason)) reloadOnce();
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
